<div class="fixed inset-0 z-[9999] flex items-center justify-center">
  <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" (click)="close.emit()"></div>
  <div class="relative bg-white rounded-2xl shadow-2xl w-[95vw] max-w-3xl max-h-[85vh] mx-4 flex flex-col overflow-hidden">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-[#E5E7EB] flex-shrink-0">
      <h3 class="text-lg font-semibold text-[#111827]">{{ title }}</h3>
      <button type="button" (click)="close.emit()" class="p-2 rounded-lg hover:bg-[#F3F4F6] transition-colors cursor-pointer">
        <fa-icon [icon]="faTimes" class="text-[#6B7280]"></fa-icon>
      </button>
    </div>
    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 py-5 text-sm text-[#374151] leading-relaxed space-y-4">
      <h4 class="text-base font-bold text-[#111827]">CONDICIONES GENERALES DE USO, AVISO LEGAL Y LIMITACIÓN DE RESPONSABILIDAD – ARDIA</h4>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">IDENTIFICACIÓN DEL SERVICIO</h5>
        <p>ARDIA es una plataforma tecnológica que proporciona agentes de inteligencia artificial orientados a la mejora de la productividad empresarial, automatización de tareas y asistencia en procesos internos de pequeñas y medianas empresas.</p>
        <p class="mt-2">El servicio consiste en la generación de respuestas, análisis, sugerencias y automatizaciones basadas en la información proporcionada por el usuario y/o conectada mediante integraciones con sistemas externos.</p>
      </div>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">NATURALEZA DEL SERVICIO</h5>
        <p>ARDIA es una herramienta de apoyo y asistencia tecnológica.</p>
        <p class="mt-2">Las respuestas generadas por ARDIA:</p>
        <ul class="list-disc pl-5 mt-1 space-y-1">
          <li>Son automáticas.</li>
          <li>Se basan en modelos de inteligencia artificial.</li>
          <li>Pueden contener errores, imprecisiones o interpretaciones incorrectas.</li>
          <li>No constituyen asesoramiento legal, fiscal, laboral, financiero ni profesional.</li>
          <li>No sustituyen el criterio humaño ni la validación empresarial.</li>
        </ul>
        <p class="mt-2">El usuario reconoce expresamente que ARDIA no toma decisiones por la empresa ni actúa en su nombre.</p>
      </div>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">OBLIGACIÓN DE VALIDACIÓN POR PARTE DEL USUARIO</h5>
        <p>El usuario es el único responsable de verificar y validar cualquier información generada por ARDIA antes de:</p>
        <ul class="list-disc pl-5 mt-1 space-y-1">
          <li>Tomar decisiones empresariales.</li>
          <li>Realizar acciones contables.</li>
          <li>Presentar documentación ante organismos oficiales.</li>
          <li>Modificar datos en su ERP o sistemas internos.</li>
          <li>Comunicar información a terceros.</li>
        </ul>
        <p class="mt-2">En particular, el usuario reconoce que:</p>
        <ul class="list-disc pl-5 mt-1 space-y-1">
          <li>Las respuestas generadas por ARDIA no son vinculantes y deberán ser contrastadas con los datos oficiales de la empresa en su ERP, sistema de gestión o fuente primaria correspondiente antes de su utilización.</li>
          <li>ARDIA no garantiza que la información generada esté actualizada, completa o alineada con la realidad contable, fiscal o legal de la empresa.</li>
        </ul>
      </div>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">LIMITACIÓN DE RESPONSABILIDAD</h5>
        <p>ARDIA no será responsable de:</p>
        <ul class="list-disc pl-5 mt-1 space-y-1">
          <li>Errores derivados del uso de la información generada.</li>
          <li>Decisiones empresariales tomadas en base a respuestas no verificadas.</li>
          <li>Pérdidas económicas, sanciones administrativas o daños indirectos derivados del uso del servicio.</li>
          <li>Interpretaciones erróneas de normativa laboral, fiscal o mercantil.</li>
          <li>Resultados derivados de integraciones con terceros (ERP, CRM, WhatsApp, etc.).</li>
        </ul>
        <p class="mt-2">El usuario asume la responsabilidad total del uso que realice de la información proporcionada por la plataforma.</p>
      </div>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">INTEGRACIONES Y DATOS DE TERCEROS</h5>
        <p>Cuando ARDIA se conecte con sistemas externos (ERP, CRM, herramientas de colaboración, WhatsApp u otros):</p>
        <ul class="list-disc pl-5 mt-1 space-y-1">
          <li>La exactitud de la información dependerá de la correcta configuración de dichas integraciones.</li>
          <li>ARDIA no garantiza la integridad o actualización automática de dichos datos.</li>
          <li>El usuario es responsable de proporcionar credenciales válidas y autorizaciones legítimas.</li>
        </ul>
      </div>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">PROTECCIÓN DE DATOS</h5>
        <p>ARDIA tratará los datos conforme a la normativa vigente en materia de protección de datos (RGPD y normativa nacional aplicable).</p>
        <p class="mt-2">El usuario declara que:</p>
        <ul class="list-disc pl-5 mt-1 space-y-1">
          <li>Tiene legitimación para tratar y compartir los datos que incorpore en la plataforma.</li>
          <li>No utilizará ARDIA para procesar datos sin base legal.</li>
          <li>Es responsable de la información personal o sensible que introduzca.</li>
        </ul>
      </div>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">DISPONIBILIDAD DEL SERVICIO</h5>
        <p>ARDIA podrá actualizar, modificar o interrumpir funcionalidades con fines de mejora, mantenimiento o evolución tecnológica.</p>
        <p class="mt-2">No se garantiza disponibilidad ininterrumpida del servicio.</p>
      </div>

      <div>
        <h5 class="font-bold text-[#111827] mb-1">ACEPTACIÓN</h5>
        <p>La utilización de la plataforma y la introducción de datos bancarios para la activación del servicio implican la aceptación íntegra de las presentes condiciones.</p>
        <p class="mt-2">El usuario declara haber leído, comprendido y aceptado expresamente:</p>
        <ul class="list-disc pl-5 mt-1 space-y-1">
          <li>Que ARDIA es una herramienta de apoyo.</li>
          <li>Que las respuestas no son vinculantes.</li>
          <li>Que debe contrastar la información con sus sistemas oficiales.</li>
          <li>Que asume la responsabilidad de las decisiones empresariales adoptadas.</li>
        </ul>
      </div>

      <div class="pt-2 border-t border-[#E5E7EB] text-xs text-[#9CA3AF]">
        <p>Versión: 1.0</p>
        <p>Fecha de entrada en vigor: 18/02/2026</p>
      </div>
    </div>
  </div>
</div>
